import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "component-variable__footer" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "component-variable__footer__prefix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle" })
], -1 /* HOISTED */);
const _hoisted_3 = {
    key: 1,
    class: "component-variable__footer__message"
};
const _hoisted_4 = { class: "component-variable__footer__controls" };
import { canHaveImpact } from 'src/shared/store/component-graph/types';
import Tooltip from 'src/shared/v-components/ui/Tooltip.vue';
import ComponentVariableImpactMessage from './ComponentVariableImpactMessage.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableDirtyFooter',
    props: {
        nodeType: {},
        componentId: {},
        variableName: {}
    },
    emits: ["reset"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // emit reset event
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_unref(canHaveImpact)(_ctx.nodeType))
                    ? (_openBlock(), _createBlock(ComponentVariableImpactMessage, {
                        key: 0,
                        "component-id": _ctx.componentId,
                        "variable-name": _ctx.variableName
                    }, null, 8 /* PROPS */, ["component-id", "variable-name"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, " This setting has been modified ")),
                _createElementVNode("span", _hoisted_4, [
                    _createVNode(Tooltip, { message: 'Discard Changes' }, {
                        default: _withCtx(() => [
                            _createElementVNode("i", {
                                class: "fa fa-undo",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('reset')))
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
